import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SubBanner from '../components/SubBanner';
import ModularBlocks from '../components/ModularBlocks';
import NewsletterSignup from '../components/NewsletterSignup';

const DefaultPageTemplate = ({
  data: {
    contentfulPage: {
      title,
      metaDescription,
      noIndex,
      ogImage,
      bannerOverline,
      bannerHeading,
      bannerText,
      bannerImage,
      shorterBanner,
      modularBlocks,
      addNewsletterSignUp,
    },
  },
  location,
}) => (
  <Layout
    seo={{
      title: title,
      metaDescription: metaDescription,
      noIndex: noIndex,
      location: location,
      ogImage: ogImage,
    }}
  >
    <main>
      <SubBanner
        heading={bannerHeading || title}
        overline={bannerOverline}
        text={bannerText}
        image={bannerImage}
        isShorter={shorterBanner}
        isDefaultPage={true}
      />
      <ModularBlocks items={modularBlocks} />
      {addNewsletterSignUp && <NewsletterSignup />}
    </main>
  </Layout>
);

export const DefaultPageTemplateQuery = graphql`
  query DefaultPageTemplateQuery($id: String!) {
    contentfulPage(id: { eq: $id }) {
      title
      metaDescription
      noIndex
      ogImage: bannerImage {
        ...SeoOgImageFragment
      }
      bannerOverline
      bannerHeading
      bannerText {
        raw
      }
      bannerImage {
        ...SubBannerLargeImageFragment
      }
      shorterBanner
      modularBlocks {
        ...AccordionModularBlockFragment
        ...ContentModularBlockFragment
        ...CustomerReviewsModularBlockFragment
        ...FeaturedPlansModularBlockFragment
        ...InstagramFeedModularBlockFragment
        ...LatestCommunityStoriesModularBlockFragment
        ...MapLocationsModularBlockFragment
      }
      addNewsletterSignUp
    }
  }
`;

export default DefaultPageTemplate;
